/* Всплывающее окно на IPhone при загрузке файлов.
 * Хранится число от 1 до 4 - необходимо показывать эту подсказку не больше 3х раз
 *  */
export const IPHONE_NOTIFY_POPUP = 'iphoneNotifyPopup';
